import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import usersStore from '@/store/users';

@Component
export default class RequestResetPassword extends Vue {

    // User Id
    @Prop({ default: '' }) private readonly id?: string;

    private username = '';

    get loading(): boolean {
        return appStore.isLoading;
    }

    private async reset() {

        this.$buefy.dialog.confirm({
            title: 'Reset di Password',
            message: 'Sei sicuro/a di voler chiedere reset della password ?',
            confirmText: 'Conferma',
            cancelText: 'Annulla',
            type: 'is-warning',
            hasIcon: true,
            onConfirm: async () => {
                await this.resetAsync();
            },
        });
    }

    private async resetAsync() {
        await usersStore.requestResetPasswordAsync(
            {
                username: this.username,
            })
            .then(() => { this.$emit('close'); })
            .catch((reason) => {
                appStore.error({ message: 'Si sono verificati errori nella richiesta di reset della password.' });
            });
    }
}